import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Services from './Services';
import About from './About';
import GalerieReact from './Galerie';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Ressources from './Ressources';
import Contact from './Contact';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

const Home = () => {
  return (
    <div className="min-h-screen bg-warm-50">
      <Header />
      <Hero />
      <Services />
      <About />
      <GalerieReact />
      <Testimonials />
      <FAQ />
      <Ressources />
      <Contact />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Home;